import ProductList from './ProductList.view';

export default ProductList;
